import styled from 'styled-components'

import { Flex } from 'Components/UI/_Legacy'

export const Container = styled(Flex).attrs({
  width: 1,
  py: [9, 9, 13],
})`
  justify-content: center;
`

export const Content = styled(Flex)`
  flex-direction: column;

  p,
  h2 {
    margin: 0;
  }

  p {
    font-size: 16px;
  }

  ul {
    margin: 0;
    list-style: disc;
  }
`

export const Row = styled(Flex).attrs({
  alignItems: ['flex-start', 'flex-start', 'center'],
  flexDirection: ['column-reverse', 'column-reverse', 'row'],
})`
  width: 100%;
  justify-content: space-between;
`
